module.exports = __webpack_public_path__ + "img/icon-clock-co.94a87756.png";